import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';
import {
    COMMERCIAL_TICKET_CREATE,
    COMMERCIAL_TICKET_UPDATE,
    COMMERCIAL_TICKET_RESET,
} from '../../actions/commercial/actionCommercialTicket';
import {COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR} from '../../actions/commercial/actionCommercialAttachment';
import {
    COMMERCIAL_RESET_REDIRECT,
    COMMERCIAL_SET_LOCK_TICKET
} from '../../actions/commercial/actionCommercialLockTicket';

export const commercialTicket = (state = {
    correlationId: null,
    isTicketLoading: false,
    isTicketCreating: false,
    created: false,
    ticket: {},
    logs: [],
    messages: {},
    attachments: [],
    newAttachments: [],
}, action) => {
    switch (action.type) {
        case COMMERCIAL_TICKET_UPDATE:
        case COMMERCIAL_TICKET_CREATE: {
            const {newAttachments} = action.payload;
            return Object.assign({}, state, {
                newAttachments,
                isTicketCreating: true,
                created: false,
                isTicketLoading: true,
                logs: [],
                attachments: [],
                messages: {},
            });
        }
        case COMMERCIAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLoading: false,
                isTicketCreating: false,
                created: false,
                ticket: {},
                messages: {},
                logs: [],
                attachments: [],
                newAttachments: [],
            });
        }
        //command accepted
        case commercialWebsocketCommands.COMMERCIAL_TICKET_CREATED:
        case commercialWebsocketCommands.COMMERCIAL_TICKET_UPDATED:
        case commercialWebsocketCommands.COMMERCIAL_GET_TICKET: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketCreating: false,
                created: true,
                isTicketLoading: true,
                correlationId
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_TICKET_SEND: {
            const {ticket, correlationId, messages, logs, attachments, error} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            if (error) {
                return Object.assign({}, state, {isTicketLoading: false, correlationId});
            }
            return Object.assign({}, state, {
                isTicketLoading: false,
                correlationId,
                ticket,
                logs,
                attachments,
                messages,
            });
        }
        //att done + error
        case COMMERCIAL_ATTACHMENTS_UPLOADING_ERROR:
        case commercialWebsocketCommands.COMMERCIAL_ATTACHMENTS_SAVED_ERROR: {
            return Object.assign({}, state, {
                newAttachments: [],
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketLoading: true,
                correlationId,
                newAttachments: [],
            });
        }
        default:
            return state;
    }
};

export const commercialLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case commercialWebsocketCommands.COMMERCIAL_TICKET_LOCKED_ERROR:
        case commercialWebsocketCommands.COMMERCIAL_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case COMMERCIAL_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case COMMERCIAL_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
